import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import contractUserApi, { setToken, isLoggedIn } from '../../api/contractUserClient';
import './My.css';

export default function MyLogin() {
  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);
  const [eventId, setEventId] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn()) navigate('/my/contracts', { replace: true });
  }, [navigate]);

  useEffect(() => {
    contractUserApi.getAvailableEvents()
      .then((data) => setEvents(data))
      .catch(() => setError('업무 목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'))
      .finally(() => setEventsLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!eventId || !phone || !password) {
      setError('업무, 휴대폰 번호, 비밀번호를 모두 입력해 주세요.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await contractUserApi.login(eventId, phone, password);
      setToken(data.token, data.employeeName);
      navigate('/my/contracts', { replace: true });
    } catch (err) {
      setError(err.message || '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my-login">
      <form className="my-login__card" onSubmit={handleSubmit}>
        <div className="my-login__logo">
          <img src="/logo.png" alt="주식회사 허브" className="my-login__logo-img" />
          <div>
            <div className="my-login__logo-kr">주식회사 허브</div>
            <div className="my-login__logo-en">근로자 전용 페이지</div>
          </div>
        </div>
        <h1>근로계약서 확인</h1>
        <p className="my-login__sub">참여하신 업무를 선택하고<br />휴대폰 번호와 비밀번호를 입력해 주세요.</p>

        {error && <div className="form-error">{error}</div>}

        <div className="form-group">
          <label>업무 선택 <span className="required">*</span></label>
          {eventsLoading ? (
            <p className="my-login__hint">업무 목록을 불러오는 중입니다...</p>
          ) : events.length === 0 ? (
            <p className="my-login__hint">현재 선택 가능한 업무가 없습니다. 관리자에게 문의해 주세요.</p>
          ) : (
            <select value={eventId} onChange={(e) => setEventId(e.target.value)}>
              <option value="">업무를 선택해 주세요</option>
              {events.map((ev) => (
                <option key={ev.id} value={ev.id}>
                  {ev.name} ({ev.regionSido} {ev.regionSigungu})
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="form-group">
          <label>휴대폰 번호 <span className="required">*</span></label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="010-0000-0000"
            autoComplete="tel"
          />
        </div>

        <div className="form-group">
          <label>비밀번호 <span className="required">*</span></label>
          <input
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="등록 시 안내받은 비밀번호 입력"
            autoComplete="off"
          />
          <p className="my-login__hint">관리자에게 안내받은 비밀번호를 입력해 주세요.</p>
        </div>

        <button type="submit" className="btn btn-primary my-login__submit" disabled={loading || eventsLoading}>
          {loading ? '확인 중...' : '로그인'}
        </button>
      </form>
    </div>
  );
}
